import React from 'react';
import { LABEL, OFFICE_TITLE } from '@moxie/constants';
import { Button, Table, TableUserNameCard } from '@shared-components/elements';
import {
  IOfficeBranch,
  IOfficeColumn,
  ITableProps,
} from '@shared-components/models';
import { PlusOutlined } from '@ant-design/icons';
import { TableBranchNameCard } from './table-branch-name-card';
// import Can, { PermissionAction, PermissionObjects } from '@crm/privilege';
import { useAppDispatch } from '@crm/core';
// import { RootState } from 'apps/crm/src/core/store';
import { userActions } from '@crm/core';
import { useCanAccess } from '@crm/libs/privilege/useCanAccess';


export const columns = (props: ITableProps): IOfficeColumn[] => {
  const { deleteData, showDrawer,canAccess } = props;

  return [
    {
      title: LABEL.NAME,
      key: 'name',
      width: 200,
      sorter: () => 0,
      render(index:number,data: IOfficeBranch) {
        return (
          <TableBranchNameCard
            data={data}
            showDrawer={showDrawer}
            deleteData={deleteData}
            canAccess={canAccess}
          />
        );
      },
    },
    {
      title: LABEL.CITY,
      dataIndex: 'city',
      sorter: () => 0,
      width: 200,
      render(_dataIndex: any, data: IOfficeBranch) {
        return (
          <div className="initial_capital">
            {data?.address?.city ? data?.address?.city : '-'}
          </div>
        );
      },
    },
    {
      title: LABEL.COUNTRY,
      dataIndex: 'country',
      sorter: () => 0,
      width: 200,
      render(_dataIndex: any, data: IOfficeBranch) {
        return data.address?.country ? data.address?.country : '-';
      },
    },
    {
      title: LABEL.MOBILE,
      key: 'mobile',
      width: 200,
      render(data: IOfficeBranch) {
        return data.mobile ? data.mobile : '-';
      },
    },
    {
      title: LABEL.CONTACT_PERSON,
      key: 'contact_person_id',
      width: 200,
      render(data: IOfficeBranch) {
        return data?.contactPerson ? (
          <TableUserNameCard
            index={data.contactPerson.id}
            actionBar={false}
            firstName={data.contactPerson.first_name || ''}
            lastName={data.contactPerson.last_name || ''}
            email={data.contactPerson.email || ''}
            id={data.contactPerson.id}
          />
        ) : (
          '-'
        );
      },
    },
  ];
};

const OfficeTableList: React.FC<ITableProps> = ({
  getData,
  deleteData,
  refreshTable,
  showDrawer,
}: ITableProps) => {
  const canAccess = useCanAccess();

  const columnActions = {
    deleteData: deleteData,
    showDrawer: showDrawer,
    canAccess
  };

  // const currentUser = useAppSelector((store: RootState) => store.auth.user);
  const dispatch = useAppDispatch();

  return (
    <div className="bg-white padding-top-2" data-testid="crm_branch_list">
      <Table
        action={getData}
        columns={columns(columnActions)}
        tableName={OFFICE_TITLE}
        refresh={refreshTable}
        filterOptions={true}
        tableButtons={
          <>
          {
            canAccess('branch','create') && (<Button
              type="primary"
              data-testid="crm-addbranch-btn"
              typeof="button"
              onClick={() => {
                dispatch(userActions.fetchUsers() as any);
                showDrawer && showDrawer();
              }}
            >
              <PlusOutlined /> {LABEL.CREATE_NEW_BRANCH}
            </Button>)
          }
          </>
        }
      />
    </div>
  );
};

export default OfficeTableList;
